function getNoCorrectAnswerMarkup({ answerId }) {
  const user_answer = $(`input[data-quiz-choiceuuid="${answerId}"]`)[0].value;
  return `<p class="reimagine-quiz-answer"><i class="fa fa-check" aria-hidden="true"></i> You answered: ${user_answer}</p>`;
}

export { getNoCorrectAnswerMarkup };